import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { cashManager } from "../../data/managers/CashManager";
import { CashSessionModel } from "../../data/models/cash/CashModel";

export function useCashSession() {
  const [cashSession, setCash] = useState<CashSessionModel | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("id");

  const fetchCashSession = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const resp = await cashManager.getCashSession(sessionId!);
      setCash(resp!);
    } catch (err) {
      console.error(err);
      setError("Error cargando la caja");
    } finally {
      setLoading(false);
    }
  }, []);

  const updateOpeningBalance = async ({
    sessionId,
    openingBalance,
  }: {
    sessionId: string;
    openingBalance: number;
  }) => {
    try {
      setLoading(true);
      setError(null);
      const resp = await cashManager.updateOpeningBalance({
        sessionId,
        openingBalance,
      });
      if (!resp) {
        throw new Error("Error actualizando el balance de apertura");
      }
      fetchCashSession();
    } catch (err) {
      console.error(err);
      setError("Error cargando la caja");
    } finally {
      setLoading(false);
    }
  };

  const closeCashSession = async ({
    sessionId,
    reportedClosingAmount,
  }: {
    sessionId: string;
    reportedClosingAmount: number;
  }) => {
    try {
      setLoading(true);
      setError(null);
      const resp = await cashManager.closeCashSession({
        sessionId,
        reportedClosingAmount,
      });
      if (!resp) {
        throw new Error("Error actualizando el cierre de la caja");
      }
      fetchCashSession();
    } catch (err) {
      console.error(err);
      setError("Error cargando la caja");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCashSession();
  }, [fetchCashSession]);

  return {
    cashSession,
    loading,
    error,
    fetchCashSession,
    updateOpeningBalance,
    closeCashSession,
  };
}
